module.exports = __webpack_public_path__ + "static/media/logo_main.8ccd0b87.svg";